<template>
  <div>
    <h1>Viajes</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar viaje"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="3" class="my-1">
        <b-form-group label-cols-sm="3" label="Tipos de viaje" class="mb-0">
          <b-form-select v-model="tripType" @change="searchByType(tripType)" :options="tripTypes" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="card">
        <div class="card-body">
            <a-form>
                <div class="row">
                    <div class="col-md-6">
                        <a-form-item label="Fecha Inicio" has-feedback>
                            <a-date-picker v-model="startDate" style="width: 100%" @change="changeStartDate"/>
                        </a-form-item>
                    </div>
                    <div class="col-md-6">
                        <a-form-item label="Fecha Fin" has-feedback>
                            <a-date-picker v-model="endDate" style="width: 100%" @change="changeEndDate"/>
                        </a-form-item>
                    </div>
                </div>
            </a-form>
        </div>
    </div>
    <b-table
      show-empty
      stacked="md"
      :items="getTripsDateRange"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      :key="tableIndex"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
      <template v-slot:cell(totalTripAmount)='row' >
        {{ '$'+ row.item.totalTripAmount}}
      </template>
    <!--totalTripAmount
      <template v-slot:cell(origin)='row' >
        <p v-if="currentPageItemsAddresses[row.item.id]">{{currentPageItemsAddresses[row.item.id].origin}}</p>
      </template>
      <template v-slot:cell(destiny)='row' >
        <p v-if="currentPageItemsAddresses[row.item.id]">{{currentPageItemsAddresses[row.item.id].destiny}}</p>
      </template> -->
      <template v-slot:cell(cancelled)='row' >
        <!--<p v-if="currentPageItemsAddresses[row.item.id]">{{currentPageItemsAddresses[row.item.id].destiny}}</p>-->
        {{ row.item.cancelled ? 'Cancelado' : 'Completado' }}
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getTripsDateRange.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
// import { useToast } from 'vue-toastification/composition'
// import { createToastInterface, POSITION } from 'vue-toastification'
const GET_TRIPS_BY_APP = gql`
  query getTripsByAppAndDate($startDate:String, $endDate: String){
    getTripsByAppAndDate(startDate: $startDate endDate: $endDate){
      id
      pickUpLng
      pickUpLat
      destinationLat
      destinationLng
      startedAt
      finishedAt
      tripOrigin
      tripDestination
      driver{
        id
        firstName
        lastName
      }
      concesion{
        id
        concesionNumber
        concesionario{
          id
          name
        }
      }
      cancelled
      totalTripAmount
    }
  }
`
const GET_TRIPS_WITHOUT_APP = gql`
query getTripswithoutAppAndDate($startDate:String, $endDate: String){
  getTripswithoutAppAndDate(startDate: $startDate endDate: $endDate){
    id
    pickUpLng
    pickUpLat
    destinationLat
    destinationLng
    startedAt
    finishedAt
    tripOrigin
    tripDestination
    driver{
      id
      firstName
      lastName
    }
    concesion{
      id
      concesionNumber
      concesionario{
        id
        name
      }
    }
    cancelled
    totalTripAmount
  }
}
`
export default {
  data() {
    return {
      counter: 0,
      getTripsDateRange: [],
      filteredItems: [],
      fields: [
        { key: 'id', label: 'ID de viaje', sortable: true, sortDirection: 'desc' },
        { key: 'tripOrigin', label: 'Origen' },
        { key: 'tripDestination', label: 'Destino' },
        { key: 'startedAt', label: 'Fecha y hora de inicio' },
        { key: 'finishedAt', label: 'Fecha y hora de fin' },
        { key: 'driver.firstName', label: 'Nombre(s) del conductor' },
        { key: 'driver.lastName', label: 'Apellidos del conductor' },
        { key: 'totalTripAmount', label: 'Costo Total' },
        { key: 'concesion.concesionNumber', label: 'Número de concesión' },
        { key: 'concesion.concesionario.name', label: 'Concesionario' },
        { key: 'cancelled', sortable: true, label: 'Estatus de viaje' },
      ],
      currentPageItemsAddresses: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      startDate: null,
      endDate: null,
      tableIndex: 0,
      tripTypes: ['Aplicación', 'Todos', 'Sin Aplicación'], // 'Sin Aplicacion'],
      tripType: null,
    }
  },
  apollo: {
    getTripsDateRange: {
      query: gql`query getTripsDateRange($startDate:String, $endDate: String){
          getTripsDateRange(startDate: $startDate endDate: $endDate){
            id
            pickUpLng
            pickUpLat
            destinationLat
            destinationLng
            startedAt
            finishedAt
            tripOrigin
            tripDestination
            driver{
              id
              firstName
              lastName
            }
            concesion{
              id
              concesionNumber
              concesionario{
                id
                name
              }
            }
            cancelled
            totalTripAmount
        }
      }`,
      context: headers(),
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
        }
      },
      error (erro) {
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        console.log(data.getTripsDateRange)
        // var i = 0
        // data.getTripsDateRange.forEach(element => {
        //   var initTrial = element.startedAt
        //   if (initTrial.match('T')) {
        //     console.log(initTrial.slice(8, 10) + '/' + initTrial.slice(5, 7) + '/' + initTrial.slice(0, 4), initTrial.slice(-8), this.counter)
        //     data.getTripsDateRange[i].startedAt = initTrial.slice(8, 10) + '/' + initTrial.slice(5, 7) + '/' + initTrial.slice(0, 4) + ' ' + initTrial.slice(-8)
        //     console.log(element.finishedAt.slice(8, 10) + '/' + element.finishedAt.slice(5, 7) + '/' + element.finishedAt.slice(0, 4), element.finishedAt.slice(-8), this.counter)
        //     data.getTripsDateRange[i].finishedAt = element.finishedAt.slice(8, 10) + '/' + element.finishedAt.slice(5, 7) + '/' + element.finishedAt.slice(0, 4) + ' ' + element.finishedAt.slice(-8)
        //     i++
        //     // console.log('yes')
        //   }
        // })
        this.totalRows = data.getTripsDateRange.length
        // console.log(encrypt(new Date().getTime().toString()))
        /*
        if (data.getTripsDateRange) {
          data.getTripsDateRange.forEach(element => {

          })
          this.totalRows = data.getTripsDateRange.length
          this.getCurrentPageItems(this.getTripsDateRange)
        } */
      },
    },
  },
  watch: {
    /*
    currentPage: function() {
      if (this.filter) {
        this.getCurrentPageItems(this.filteredItems)
      } else {
        this.getCurrentPageItems(this.getTripsDateRange)
      }
    },
    */
  },
  methods: {
    /*
    async getCurrentPageItems(items) {
      // console.log('Items per page')
      const firstIndex = (this.currentPage - 1) * 10
      const lastIndex = this.currentPage * 10
      const currentPageItems = items.slice(firstIndex, lastIndex)
      this.currentPageItemsAddresses = []
      for (const item of currentPageItems) {
        const origin = await this.getAddressFromCoords(item.pickUpLat, item.pickUpLng)
        const destiny = await this.getAddressFromCoords(item.destinationLat, item.destinationLng)
        this.currentPageItemsAddresses[item.id] = { origin: origin, destiny: destiny }
      }
      this.tableIndex += 1
      // console.log(this.currentPageItemsAddresses)
    },
    async getAddressFromCoords(lat, lng) {
      const response = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${lat},${lng}&key=AIzaSyB1VC22f38_ZxRfU2t5duK_kfChhXoKYF8`)
      return response.data.results[0].formatted_address
    },
    */
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: variant,
      })
    },
    onFiltered(filtered) {
      // console.log('filtered items')
      // console.log(filteredItems)
      // this.filteredItems = filtered
      this.totalRows = filtered.length
      this.currentPage = 1
      // this.getCurrentPageItems(this.filteredItems)
    },
    searchByType(tripType) {
      if (tripType === 'Todos' || tripType === null) {
        // console.log(tripType)
        this.$apollo.queries.getTripsDateRange.skip = false
        this.$apollo.queries.getTripsDateRange.refetch()
      } else if (tripType === 'Aplicación') {
        this.getTripsByApp()
      } else {
        this.getTripWithoutApp()
      }
    },
    defineDate(date) {
      const dates = new Date(date)
      const year = (dates.getFullYear())
      var month = (parseInt(dates.getMonth() + 1))
      var day = (dates.getDate())
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return [year, month, day].join('-')
    },
    getTripsByApp() {
      this.$apollo.query({
        query: GET_TRIPS_BY_APP,
        variables: {
          startDate: this.startDate,
          endDate: this.endDate,
        },
        context: headers(),
      })
        .then(({ data }) => {
          console.log(data)
          this.totalRows = data.getTripsByAppAndDate.length
          this.$apollo.queries.getTripsDateRange.skip = true
          this.getTripsDateRange = data.getTripsByAppAndDate
        })
        .catch(error => {
          this.makeToast(true, 'danger', 'Error', 'Tiempo de espera excedido. Inténtalo más tarde')
          console.log(error)
        })
    },
    getTripWithoutApp() {
      this.$apollo.query({
        query: GET_TRIPS_WITHOUT_APP,
        variables: {
          startDate: this.startDate,
          endDate: this.endDate,
        },
        context: headers(),
      })
        .then(({ data }) => {
          console.log(data)
          if (data.getTripswithoutAppAndDate != null) {
            console.log(data.getTripswithoutAppAndDate.startedAt)
            this.totalRows = data.getTripswithoutAppAndDate.length
            this.$apollo.queries.getTripsDateRange.skip = true
            this.getTripsDateRange = data.getTripswithoutAppAndDate
          } else {
            this.$apollo.queries.getTripsDateRange.skip = true
            this.getTripsDateRange = []
            this.totalRows = 0
          }
        })
        .catch(error => {
          this.makeToast(true, 'danger', 'Error', 'Tiempo de espera excedido. Inténtalo más tarde')
          console.log(error)
        })
    },
    changeStartDate(event) {
      if (event) {
        this.startDate = this.defineDate(event._d)
        // console.log(this.tripType)
        this.searchByType(this.tripType)
      } else {
        this.todayDate()
        // this.searchByType(this.tripType)
      }
    },
    changeEndDate(event) {
      if (event) {
        this.endDate = this.defineDate(event._d)
        this.searchByType(this.tripType)
      } else {
        this.todayDate()
        // this.searchByType(this.tripType)
      }
    },
    todayDate() {
      // Use it
      const today = new Date()
      const year = (today.getFullYear())
      var month = (parseInt(today.getMonth() + 1))
      var day = (today.getDate())
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      this.startDate = [year, month, day].join('-')
      this.endDate = [year, month, day].join('-')
    },
  },
  mounted() {
    this.todayDate()
  },
}
</script>

<style>

</style>
